import smsTemplates from '../data/sms-templates.json';

export const renderSms = (templateKey, dynamicVars, intl) => {
  const template = smsTemplates[templateKey];

  return template.parts
    .map(part => {
      if (part.id) {
        const msgVars = {};
        (part.vars || []).forEach(v => {
          msgVars[v] = dynamicVars[v];
        });

        return intl.formatMessage({ id: part.id }, msgVars);
      }

      return '';
    })
    .join(' ');
};

export const findSmsByEmailsKey = transition => {
  if (!transition) return [];

  const result = [];
  const transitionValue = transition.split('/')[1];

  for (const emailName in smsTemplates) {
    const obj = smsTemplates[emailName];

    if (obj && typeof obj === 'object') {
      if (
        typeof obj.transition === 'string' &&
        obj.transition
          .split(',')
          .map(t => t.trim())
          .includes(transitionValue)
      ) {
        result.push(emailName);
      }
    }
  }

  return result;
};
